export const regExp = {
  ssn: /^(?!000)[0-9]{3}([ -]?)(?!00)[0-9]{2}\1(?!0000)[0-9]{4}$/,
  phone: /^$|^\(?([2-9][0-8][0-9])\)?[\s-]?([2-9][0-9]{2})[\s-]?([0-9]{4})$/,
  zipCode: /^\d{5}$/,
}
